//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppConfig from '@/config/app'

// 是否是H5渠道
let h5 = false

export default {
  name: 'm-process',
  data () {
    return {
      AppConfig: AppConfig,
      h5: h5
    }
  },
  mounted () {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true
    }
  },
  computed: {
    lipeiliucheng () {
      if (this.h5 && !this.$store.state.h5.configuration.isNull) {
        return '保险公司<a href="tel:400-69-12345">400-69-12345</a>申请协助'
      }
      return '致电悟空保<a href="tel:400-661-2992">400-661-2992</a>或保险公司<a href="tel:400-69-12345">400-69-12345</a>申请协助'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Process.vue